import React, { useState, useEffect } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import Select from 'react-select';
import { load_contact_profile, load_jobs_positions, save_contact_info } from '../../../../utils/crm_services';

import { invite_user } from '../../../../utils/services';
import { useNavigate } from 'react-router-dom';

// Variables globales para Firebase (no usadas, pero mantenidas para consistencia en el entorno)
const apiKey = "";
const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-05-20:generateContent?key=${apiKey}`;

// --- Definiciones de iconos SVG en línea ---
// Ajustamos el tamaño a 1rem para un mejor ajuste visual en Bootstrap.
const IconStyle = { width: '1rem', height: '1rem', marginRight: '0.5rem' };
const primaryColor = '#007bff'; // Bootstrap primary blue
const dangerColor = '#dc3545'; // Bootstrap danger red


// Iconos que usan el color primario y el estilo ajustado
const User = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={{...IconStyle, color: primaryColor}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>);
const Globe = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={{...IconStyle, color: primaryColor}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>);
const Briefcase = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={{...IconStyle, color: primaryColor}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect width="20" height="14" x="2" y="7" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>);
const Mail = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={{...IconStyle, color: primaryColor}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>);
const Phone = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={{...IconStyle, color: primaryColor}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.07 2h3a2 2 0 0 1 2 1.73 15.94 15.94 0 0 0 .74 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 15.94 15.94 0 0 0 2.81.74A2 2 0 0 1 22 16.92z"/></svg>);
// Icono de reloj (Login CRM) usa el color de peligro
const Clock = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={{...IconStyle, color: dangerColor}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>);
const MessageSquare = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={{...IconStyle, color: primaryColor}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>);

// Iconos más pequeños (botones)
const SmallIconStyle = { width: '1rem', height: '1rem', marginRight: '0.5rem' };
const Save = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={SmallIconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><path d="M17 21v-8H7v8"/><path d="M7 3v5h8"/></svg>);
const X = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={SmallIconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>);
const Sparkles = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={SmallIconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/><path d="M10.4 17.65a2.12 2.12 0 0 1-.36-3.82L12 12l2.35-1.83a2.12 2.12 0 0 1-.36-3.82 2.12 2.12 0 0 1 2.38-2.38 2.12 2.12 0 0 1-3.82-.36L12 5.6 9.65 3.77a2.12 2.12 0 0 1-3.82.36 2.12 2.12 0 0 1-2.38 2.38 2.12 2.12 0 0 1 .36 3.82L7.6 12l-2.35 1.83a2.12 2.12 0 0 1 .36 3.82 2.12 2.12 0 0 1 2.38 2.38 2.12 2.12 0 0 1 3.82-.36z"/></svg>);
const Clipboard = (props) => (<svg xmlns="http://www.w3.org/2000/svg" style={SmallIconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>);





// Opciones predefinidas para campos select
const countries = ["Chile", "México", "Colombia", "España", "Argentina", "Otro"];
const languages = [
    { code: "es", name: "Español" },
    { code: "en", name: "Inglés" },
    { code: "pt", name: "Portugués" },
];



export default function App({ token, onClose, onSet, 
    countryOptionsMnu = [],
    countryPhoneOptionsMnu = [],
    modal_param_usr_email }) {
    const [jobsOptions, setjobsOptions] = useState([]);
    const [userData, setUserData] = useState({
        id: '',
        name: '',
        position_id: '',
        country: '',
        email: '',
        phone_country_code: '',
        phone: '',
        last_login: '',
        language: '',
        countryCode: ''
    });
    const [isLoading, setIsLoading] = useState(true);
    const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
 const navigate = useNavigate();  



    // 1. Efecto para cargar los datos iniciales del usuario
    useEffect(() => {
        const loadUser = async () => {
            try {
                const data = await load_contact_profile(token, modal_param_usr_email);
                setUserData(data['usr_data'][0]);

            } catch (error) {
                console.error("Error al cargar el usuario:", error);
                setStatusMessage({ text: 'Error al cargar los datos del usuario.', type: 'error' });
            } finally {
                setIsLoading(false);
            }
        };

        if (modal_param_usr_email)  loadUser();
        fetchLoadJobs();
    }, []);

    const getJobsByValue = (value) => {
      return jobsOptions.find(option => option.value === value);
    };

     async function fetchLoadJobs() {
              const jobsList = await load_jobs_positions(token);
              if (jobsList==="INVALID"){
                  navigate("/");
              }else{
        
                 const tempjobs= jobsList.map((celement, index) => {
                  return {
                      value: celement.id,
                      label: celement.name,
                  };
                });
      
                 setjobsOptions( tempjobs);
      
              }
          }

    // 2. Manejador genérico para la mayoría de los campos del formulario
    const handleChange = (e) => {
       
        const { name, value, type, checked } = e.target;
        setUserData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    // 3. Manejador para guardar los cambios
    const handleSave = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatusMessage({ text: 'Guardando...', type: 'info' });


        try {
            const result = await save_contact_info(token,userData);
            if (result == "UPDATED") {
                setStatusMessage({ text: result.message, type: 'success' });
                
                setTimeout(() => {
                    setStatusMessage({ text: '', type: '' });
                }, 2000); 

            } else {
                setStatusMessage({ text: 'El guardado falló. Intenta de nuevo.', type: 'error' });
            }
        } catch (error) {
            console.error("Error al guardar:", error);
            setStatusMessage({ text: 'Ocurrió un error en la solicitud de guardado.', type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };


     const formatOptionLabel = ({ label, flagUrl }) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {flagUrl && <img src={flagUrl} alt={`Flag of ${label}`} style={{ width: '20px', marginRight: '10px' }} />}
        <span>{label}</span>
      </div>
    );

    const formatPhoneLabel = ({ label, flagUrl,value }) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* Muestra la bandera */}
        {flagUrl && 
            <img 
                src={flagUrl} 
                alt={`Flag of ${label}`} 
                style={{ width: '20px', marginRight: '10px' }} 
            />
        }
        {/* Muestra SOLAMENTE el INDICATIVO (value) */}
        <span>{value}</span> 
    </div>
    );
    

     const getOptionByValue = (value) => {
      return countryOptionsMnu.find(option => option.value === value);
    };

    const getcountryCodeByValue = (value) => {
      return countryPhoneOptionsMnu.find(option => option.value === value);
    };

     const validateEmail = (email) => {
      // Basic regex for email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

      function invite_new_user(emailText) {
    
        if (!validateEmail(emailText)) {
          alert("Invalid Email Address");
          return;
        }
    
        async function fetchInviteNewAddress(emailText) {
    
          const usrData = await invite_user(token, emailText);
          if (usrData === "INVALID") {
            navigate("/");
          }
          else {
            alert("Invite was sent to " + emailText);
            onClose();
          }
        }
    
        fetchInviteNewAddress(emailText);
      }

    // Renderizado del componente
    return (
        // Contenedor principal: Eliminamos h-100 para que el contenido no intente tomar la altura máxima
        <div className="p-0"> 
            {/* Eliminamos d-flex flex-column h-100 y flex-fill para que el contenido fluya y el modal pueda hacer scroll */}
            <div className="bg-white p-0"> 

                {/* Mensajes de estado fijos */}
                {statusMessage.text && (
                    <Alert 
                        variant={statusMessage.type === 'success' ? 'success' : statusMessage.type === 'error' ? 'danger' : 'primary'}
                        className="mb-0 mx-4" // Agregamos margen horizontal y eliminamos margen inferior
                    >
                        {statusMessage.text}
                    </Alert>
                )}
                
                {/* Mostrar spinner de carga o el formulario */}
                {isLoading && statusMessage.type !== 'success' ? (
                    <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                                   </div>
                        
                    </div>
                ) : (
                    // Contenedor principal del formulario (ya no tiene scroll interno ni flex)
                    <div> 
                    <div className="modal-inner">

                        {/* Contenido del formulario que se desplazará con el modal */}
                        <Form onSubmit={handleSave} className="p-3"> 
                            <div className="row g-2">
                                <div className="col-12">
                                    <FormField 
                                        label="Nombre completo del contacto" 
                                        name="name"
                                        value={userData.name}
                                        onChange={handleChange}
                                        icon={User}
                                        type="text"
                                    />
                                </div>

                                {/* Campos de 6 columnas (usamos col-sm-6 para forzar 2 columnas en modal) */}
                                {/* CAMPO 2: Email */}
                                <div className="col-12 col-sm-6">
                                    <FormField 
                                        label="Email" 
                                        name="email"
                                        value={userData.email}
                                        icon={Mail}
                                        type="email"
                                    />
                                </div>

                                {/* CAMPO 5: Teléfono */}
    <div className="col-12 col-sm-6">
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <Phone style={{ color: '#007bff', height: '18px', width: '18px' }} /> 
        {/* Etiqueta del Formulario */}
        <label className="form-label" style={{ marginRight: '8px', marginBottom: '0' }}>
            Teléfono
        </label>
        
        {/* ÍCONO MOVIDO AQUÍ */}
      
        
    </div>
    
    {/* CORRECCIÓN CLAVE: alignItems: 'center' para centrado vertical */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}> 
        
        {/* 1. Selector de Código de País */}
        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            options={countryPhoneOptionsMnu}
            value={getcountryCodeByValue(userData.phone_country_code)}
            formatOptionLabel={formatPhoneLabel}
            onChange={(selectedOption) => {
                                                    const fakeEvent = {
                                                        target: {
                                                            name: 'phone_country_code', // <- La clave en userData que quieres actualizar
                                                            value: selectedOption ? selectedOption.value : '', // <- El valor a asignar
                                                        },
                                                    };
                                                    handleChange(fakeEvent);
                                                }}
            isLoading={countryPhoneOptionsMnu.length === 0}
            isSearchable
            styles={{
                container: (provided) => ({
                    ...provided,
                    // alignSelf: 'stretch' está bien, pero 'center' en el padre es mejor
                    minWidth: '140px',
                    width: '100px',
                    flex: '0 0 auto', 
                    zIndex: 2, 
                    margin: 0, 
                }),
                control: (provided) => ({
                    ...provided,
                    minHeight: '40px', // Altura fija
                    height: '40px',     // Altura fija
                    padding: '0 8px', 
                    margin: 0, 
                }),
                singleValue: (provided) => ({
                    ...provided,
                    textAlign: 'center',
                    margin: 0, // Eliminar margen superior/inferior
                }),
                // Añadir para evitar que el input de búsqueda cree espacio extra
                input: (provided) => ({
                    ...provided,
                    margin: '0',
                    padding: '0',
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 })
            }}
        />
        

        {/* 2. Campo del Número Local */}
        <div style={{ flexGrow: 1 }}> 
            <FormField
                label="" 
                name="phone"
                value={userData.phone}
                onChange={handleChange}
                type="tel"
                placeholder="Número local"
                // Asegúrate de que el input de FormField tenga altura fija y sin margen
                inputStyle={{
                    height: '40px', 
                    // Si tu FormField tiene margen interno o padding que lo desalinea,
                    // necesitas anularlo aquí.
                }}
            />
        </div>
    </div>
</div>

                                {/* CAMPO 4: Cargo */}
                                <div className="col-12 col-sm-6">
                                     <Form.Label className="d-flex align-items-center">
                                            <Briefcase />
                                            Cargo
                                        </Form.Label>
                                      <Form.Control
                                            as="select"
                                            id="position_id"
                                            name="position_id"
                                            value={(userData.position_id)}
                                            onChange={handleChange}
                                        >
                                            <option value="">Selecciona un Cargo</option>
                                            {jobsOptions.map(l => (
                                                <option key={l.value} value={l.value}>{l.label}</option>
                                            ))}
                                        </Form.Control>
                                </div>

                                {/* CAMPO 3: País de residencia (Dropdown) */}
                                <div className="col-12 col-sm-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="d-flex align-items-center">
                                            <Globe />
                                            País de residencia
                                        </Form.Label>
                                           <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                options={countryOptionsMnu}
                                                isLoading={countryOptionsMnu.length === 0}
                                                formatOptionLabel={formatOptionLabel}
                                               onChange={(selectedOption) => {
                                                    const fakeEvent = {
                                                        target: {
                                                            name: 'country', // <- La clave en userData que quieres actualizar
                                                            value: selectedOption ? selectedOption.value : '', // <- El valor a asignar
                                                        },
                                                    };
                                                    handleChange(fakeEvent);
                                                }}
                                                value={getOptionByValue(userData.country)}
                                                placeholder="Country..."
                                                isSearchable
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        minWidth: 100,
                                                        flex: 1,
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                    </Form.Group>
                                </div>

                                {/* CAMPO 6: Idioma (Dropdown) */}
                                <div className="col-12 col-sm-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="d-flex align-items-center">
                                            <MessageSquare />
                                            Idioma
                                        </Form.Label>
                                        <Form.Control
                                            as="select"
                                            id="language"
                                            name="language"
                                            value={userData.language}
                                            onChange={handleChange}
                                        >
                                            <option value="">Selecciona un idioma</option>
                                            {languages.map(l => (
                                                <option key={l.code} value={l.code}>{l.name}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </div>
                                
                                {/* CAMPO 7: Último login CRM (Campo de solo lectura) */}
                                <div className="col-12 col-sm-6">
                                    <Form.Group className="mb-3">
                                       {userData.last_login ? (
                                                    <React.Fragment> {/* Lado TRUE: Muestra datos */}
                                                    <Form.Label className="d-flex align-items-center text-danger">
                                                        <Clock />
                                                        Último Login CRM
                                                    </Form.Label>
                                                    <p className="form-control bg-light text-muted">
                                                        {userData.last_login || "No disponible"}
                                                    </p>
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                    <Form.Label className="d-flex align-items-center text-danger"> {/* Lado FALSE: Un solo elemento */}
                                                     Invitar a unirse al CRM
                                                    </Form.Label>
                                                     <Button
                                                                      variant="success"
                                                                      size="sm"
                                                                      onClick={() => {
                                                                        invite_new_user(userData.email);
                                                                      }}
                                                                      className="w-100 mt-2"
                                                                    >
                                                                      Invite User
                                                                    </Button>
                                                    </React.Fragment>
                                                )}
                                        
                                    </Form.Group>
                                </div>

                                
                        
                            </div>
                        </Form>
                            </div>
                        {/* Botones de acción (no fijos, se desplazan con el resto del contenido) */}
                       <div className="modal-footer-fixed d-flex justify-content-end gap-3">

                            <Button
                                variant="outline-secondary"
                                onClick={onClose}
                                className="d-flex align-items-center px-4"
                            >
                                <X />
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                onClick={handleSave}
                                disabled={isLoading}
                                variant="primary"
                                className={`d-flex align-items-center px-4 ${isLoading ? 'disabled' : ''}`}
                            >
                                <Save />
                                {isLoading ? 'Guardando...' : 'Guardar Cambios'}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// Componente reutilizable para campos de texto/email/teléfono con Bootstrap
const FormField = ({ label, name, value, onChange, icon: Icon, type = 'text' }) => (
    <Form.Group className="mb-3">
        <Form.Label className="d-flex align-items-center">
            {Icon && <Icon />}
            {label}
        </Form.Label>
        <Form.Control
            id={name}
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            required
        />
    </Form.Group>
);
